import {Component} from "@angular/core";

@Component({
    selector: "fui-grouping-field",
    styleUrls: ["./grouping-field.component.scss"],
    templateUrl: "./grouping-field.component.html",
    standalone: false
})
export class FUIGroupingFieldComponent {
}
